import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { EbookMockup } from './ui/EbookMockup';
const chapters = ['Introdução ao mundo das velas aromáticas e tipos de ceras', 'Materiais, ferramentas e fornecedores essenciais', 'Técnicas de produção passo a passo (temperaturas e misturas)', 'Como evitar os erros mais comuns (furos, manchas, etc)', 'Precificação correta e cálculo de margem de lucro', 'Marketing, embalagens e estratégias de vendas online'];
export function ContentPreview() {
  return <section id="conteudo" className="py-24 lg:py-32 bg-brand-cream overflow-hidden" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-16">
          {/* Content Left */}
          <div className="w-full lg:w-1/2" data-id="element-17">
            <FadeIn direction="right" data-id="element-18">
              <span className="text-brand-gold font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-19">
                Conteúdo Completo
              </span>
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-brown mb-10" data-id="element-20">
                O que você vai aprender
              </h2>

              <ul className="space-y-6" data-id="element-21">
                {chapters.map((chapter, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1 + 0.2
              }} className="flex items-start gap-5 group" data-id="element-22">
                    <div className="w-10 h-10 rounded-full bg-white border-2 border-brand-rose flex items-center justify-center text-brand-rose font-bold font-serif shrink-0 group-hover:bg-brand-rose group-hover:text-white transition-colors" data-id="element-23">
                      0{index + 1}
                    </div>
                    <span className="text-brand-brown/80 text-lg font-medium pt-1.5" data-id="element-24">
                      {chapter}
                    </span>
                  </motion.li>)}
              </ul>
            </FadeIn>
          </div>

          {/* Image Right */}
          <div className="w-full lg:w-1/2 flex justify-center" data-id="element-25">
            <FadeIn direction="left" delay={0.3} data-id="element-26">
              <div className="relative" data-id="element-27">
                {/* Decorative background blob */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-brand-gold/20 rounded-full blur-3xl" data-id="element-28"></div>
                <EbookMockup size="md" data-id="element-29" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}